//タッチスクリーン判定
const getisTouchscreen = () => {
    let isTouchScreen = false;
    if (typeof window !== 'undefined' && window.ontouchstart === null) isTouchScreen = true;
    return isTouchScreen
}

export default getisTouchscreen

